export default __webpack_public_path__ + "static/children-d31158144c1f53c982c71ef14aab8e05.jpg";